import Section from '../shared/Section';
import PriceAutomation from './PriceAutomationPage/PriceAutomation';
import { SkuStatusForm } from './SkuStatusForm/SkuStatusForm';

import { ApiAvailableStore } from '../types/enums/store.enum';

export const GooglePriceAutomationPage = () => {
    return (
        <>
            <Section title={'Google Play Price Automation'}>
                <PriceAutomation store={ApiAvailableStore.GOOGLE} />
            </Section>
            <Section title={'Google Play SKU Status'}>
                <SkuStatusForm store={ApiAvailableStore.GOOGLE} />
            </Section>
        </>
    );
};
